import React from 'react'
import './About.css'
import {FaAward} from 'react-icons/fa'
import {VscFolderLibrary} from 'react-icons/vsc'


const About = () => {
  return (
    <section id='about'>
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className="container about_container">
      <div className="about_content">
        <div className="about_cards">
          <article className='about_card'>
            <FaAward className='about_icon'/>
            <h5>Experience</h5>
            <small>5+ Big Website Clone</small>
          </article>

          <article className='about_card'>
            <VscFolderLibrary className='about_icon'/>
            <h5>Projects</h5>
            <small>50+ Small Projects</small>
          </article>
        </div>
        <p>Quick learner and an aspiring full-stack web developer with core knowledge of MERN stack technology. Looking for a challenging role in a reputable organization to utilize my technical, database, and management skills for the growth of the organization as well as to enhance my knowledge about new and emerging trends in the IT sector.</p>

          <a href="#contact" className='btn btn-primary'>Let's Talk</a>
      </div>

      </div>
    </section>
  )
}

export default About